import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/modern.css';

const Nav = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    // Close any open dropdown when closing the mobile menu
    if (isMobileMenuOpen) {
      setActiveDropdown(null);
    }
  };

  const toggleDropdown = (dropdownName, e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (window.innerWidth <= 768) {
      setActiveDropdown(currentDropdown => 
        currentDropdown === dropdownName ? null : dropdownName
      );
    }
  };

  return (
    <nav className="nav-container">
      <div className="nav-content">
        <Link to="/" className="nav-logo-container">
          <img 
            src="https://static.shuffle.dev/uploads/files/b6/b6e1fbcee32be55e5cc2132ff8ec8b0cd9dc9d4b/logo.jpg" 
            alt="HCB Logo" 
            className="nav-logo"
          />
        </Link>

        <button 
          className="mobile-menu-button" 
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            {isMobileMenuOpen ? (
              <path d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>

        <div className={`nav-links ${isMobileMenuOpen ? 'mobile-active' : ''}`}>
          <div className={`nav-item ${activeDropdown === 'academics' ? 'active' : ''}`}>
            <button 
              className="nav-link"
              onClick={(e) => toggleDropdown('academics', e)}
            >
              Academics
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className="nav-arrow">
                <path d="M2 5l4 4 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <div className="dropdown-content">
              <Link to="/academics/doctoral_programs" className="dropdown-item">Doctoral Program</Link>
              <Link to="/academics/hamilton_business_school" className="dropdown-item">Hamilton School of Business</Link>
              <Link to="/academics/college_christian_studies" className="dropdown-item">Jakhotia College of Spiritual Studies</Link>
              <Link to="/academics/college_guidance" className="dropdown-item">College Of Guidance and Counseling Psychology</Link>
              <Link to="/academics/college_education" className="dropdown-item">Wood School of Education</Link>
            </div>
          </div>

          <div className={`nav-item ${activeDropdown === 'catalog' ? 'active' : ''}`}>
            <button 
              className="nav-link"
              onClick={(e) => toggleDropdown('catalog', e)}
            >
              Catalog
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className="nav-arrow">
                <path d="M2 5l4 4 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <div className="dropdown-content">
              <Link to="/catalog" className="dropdown-item">General Information</Link>
              <Link to="/catalog/school_information" className="dropdown-item">School Information</Link>
              <Link to="/catalog/admissions" className="dropdown-item">Admissions</Link>
              <Link to="/catalog/education_requirements" className="dropdown-item">Education Requirements</Link>
              <Link to="/catalog/tuition" className="dropdown-item">Tuition, Fees & Tools</Link>
              <Link to="/catalog/school_policy" className="dropdown-item">School Policy</Link>
            </div>
          </div>

          <Link to="/request" className="nav-link">Contact</Link>
          <Link to="/application" className="nav-button">Apply Now</Link>
        </div>
      </div>
    </nav>
  );
};

export default Nav;